import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ProductValidationUpdateDialog from "pages/product_validation/menu/ProductValidationUpdateDialog";
import React from "react";
import { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch, useSelector } from "react-redux";
import {
  getProductValidationsThunk,
  productValidationSelector,
  deleteProductValidationThunk,
} from "store/reducers/product/productValidationSlice";

const ProductValidationList = () => {
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  useEffect(() => {
    dispatch(getProductValidationsThunk());
  }, []);
  const validations = useSelector(productValidationSelector.selectAll);
  const removeValidation = (id) => {
    dispatch(deleteProductValidationThunk(id));
  };
  const { status } = useSelector((state) => state.productValidation);
  const [currentItem, setCurrentItem] = React.useState(null);
  const [openValidationUpdate, setOpenValidationUpdate] = React.useState(false);
  const handleValidationClose = () => {
    setOpenValidationUpdate(false);
  };
  const handleEditClick = (item) => {
    setCurrentItem(item);
    setOpenValidationUpdate(true);
  };
  return (
    <Box>
      <Box
        component={Typography}
        variant="h4"
        sx={{ textDecoration: "underline", color: "text.secondary", mb: 1 }}
      >
        Product validations
      </Box>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Box
            sx={{ backgroundColor: "#e7ebf0", borderRadius: 2, flex: 1 }}
            padding={1}
          >
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ minWidth: 150 }}>
                      {isSmallScreen ? "Name" : "Offer name"}
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: 120 }}>
                      {isSmallScreen ? "Desc" : "Offer description"}
                    </TableCell>
                    <TableCell align="center">
                      {isSmallScreen ? "Logic" : "Logic code"}
                    </TableCell>
                    <TableCell align="center" sx={{ minWidth: 100 }}>
                      Image
                    </TableCell>
                    <TableCell>&nbsp;</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {validations.map((validation) => (
                    <TableRow
                      key={validation.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {validation.name}
                      </TableCell>
                      <TableCell align="center">{validation.desc}</TableCell>
                      <TableCell align="center">{validation.logic}</TableCell>
                      <TableCell align="center">
                        {validation.image ? (
                          <LazyLoadImage
                            width={100}
                            height={100}
                            src={validation.image}
                            style={{ objectFit: "contain" }}
                          />
                        ) : (
                          <Typography color="text.secondary"> None </Typography>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Button
                          variant="outlined"
                          onClick={() => handleEditClick(validation)}
                        >
                          Edit
                        </Button>
                      </TableCell>
                      <TableCell align="center">
                        <LoadingButton
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            removeValidation(validation.id);
                          }}
                          loading={
                            status?.loading === "delete" && validation.id
                          }
                        >
                          Delete
                        </LoadingButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Grid>
      </Grid>
      <ProductValidationUpdateDialog
        open={openValidationUpdate}
        handleClose={handleValidationClose}
        validation={currentItem}
      />
    </Box>
  );
};

export default ProductValidationList;
